import { Component, OnInit, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { DevedorService, LoadingService } from '../../services';

@Component({
  selector: 'app-mediaplayer',
  templateUrl: './mediaplayer.component.html',
  styleUrls: ['./mediaplayer.component.scss']
})
export class MediaplayerComponent implements OnInit {
  @ViewChild('audio') audio: ElementRef;  
  @Input() telefoneServico: string;
  @Input() numeroAudio: number;
  @Input() audioId: number;
  audioLigacao: any = [];
  showplay: boolean = true;
  showload: boolean = false;
  
  constructor(private _service: DevedorService, private _loading: LoadingService) {
  }

  ngOnInit() {     
    this.audio.nativeElement.onplay = () => {      
      this.showload = false;
      this.showplay = false;
    };    
  }  

  carregarAdudio() {
    this.showload = true;    
    this._service.getAudio(this.audioId).subscribe(result => {
      this.audioLigacao = result;      
      this.audio.nativeElement.src = this.audioLigacao.arquivoNome;
      if(screen.width < 640 || screen.height < 480) {
        this.showload = false;
        this.showplay = false;
      } else if (screen.width < 1024 || screen.height < 768) {
        this.showload = false;
        this.showplay = false;
      } else {
        this.audio.nativeElement.play();   
      }
    }); 
  }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/mediaplayer/mediaplayer.component.ts